import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-selecionar-pessoa-modal',
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatButtonModule,
    MatTableModule,
  ],
  templateUrl: './selecionar-pessoa-modal.html',
  styleUrl: './selecionar-pessoa-modal.scss',
})
export class SelecionarPessoaModal {
  constructor(
    public dialogRef: MatDialogRef<SelecionarPessoaModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  idSelecionado: number | null = null;
  displayedColumns: string[] = ['nome', 'area', 'cargo'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort!: MatSort;

  filterValue = '';

  async ngOnInit() {
    this.dataSource = new MatTableDataSource(this.data.pessoas);
    this.idSelecionado = this.data.pessoaSelecionada?.idPessoa ?? null;
    this.configurarFiltro();
  }

  ngAfterViewInit() {
    this.configurarSort();
  }

  private configurarFiltro() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const normalizedFilter = filter.toLowerCase();
      return (
        data.nomeCompleto.toLowerCase().includes(normalizedFilter) ||
        data.cargo?.toLowerCase().includes(normalizedFilter) ||
        data.area?.toLowerCase().includes(normalizedFilter)
      );
    };
  }

  private configurarSort() {
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (data: any, property: string) => {
      switch (property) {
        case 'nome':
          return data.nomeCompleto.toLowerCase();
        case 'area':
          return data.area;
        case 'cargo':
          return data.cargo.toLowerCase();
        default:
          return data[property];
      }
    };
  }

  aplicarFiltro(event: Event) {
    const input = event.target as HTMLInputElement;
    this.filterValue = input.value;
    this.dataSource.filter = this.filterValue.trim();
  }

  fechar() {
    this.dialogRef.close();
  }

  vincularEmpresa() {
    const itemSelecionado = this.data.pessoas.find(
      (e: any) => e.idPessoa === this.idSelecionado,
    );
    this.dialogRef.close(itemSelecionado);
  }
}
